/* eslint-disable react/jsx-props-no-spreading */
import { ReactNode } from 'react'
import MdButton from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles({
  progress: {
    color: 'white'
  }
})

type Props = {
  children: ReactNode
  disabled?: boolean
  type?: 'button' | 'submit'
  onClick: () => void
  loading?: boolean
}

export default function ButtonSecondary({ children, loading, ...rest }: Props): JSX.Element {
  const classes = useStyles()

  return (
    <MdButton
      {...rest}
      color="secondary"
      variant="contained"
      startIcon={loading ? <CircularProgress size={18} className={classes.progress} /> : null}
    >
      {children}
    </MdButton>
  )
}
